var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60243 8.67969C4.96476 6.14337 7.95277 5.05664 9.62721 4.75058C9.92605 4.69596 10.2158 4.81391 10.3699 5.07574C10.9638 6.08533 12.217 8.66549 13.1884 10.4434C13.4225 10.8719 13.3263 11.4063 12.9635 11.7332C11.8859 12.7042 10.4408 14.2101 10.6024 15.1797C11.1024 18.1797 16.1023 21.6797 17.1023 21.1797C17.9579 20.7519 19.2731 19.2602 20.1627 18.5073C20.4237 18.2865 20.7875 18.2723 21.0933 18.4252L26.7405 21.2487C27.2216 21.4893 27.428 22.0678 27.1637 22.5363C26.1218 24.384 24.1612 26.8366 22.1024 27.1797C19.1024 27.6797 13.9181 26.9953 9.60242 22.6797C4.10229 17.1797 4.10243 12.1797 4.60243 8.67969Z",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.278a87ad30daa0b81b297df7c123d48b.svg";
export { ForwardRef as ReactComponent };